/*
  Prowwl "Build your bundle" page.
  A small shared store keeps the selection (variant id + quantity) in sessionStorage and dispatches
  `prowwl-bundle:change` on document. The hero tracker, the starter kits and the builder (grid + panel)
  each listen to that event and redraw themselves. The offer (threshold, percent, discount code) comes
  from the builder section's JSON config; defaults are used when the builder is not on the page.
*/
(function () {
  'use strict';
  if (window.PwBundle) return;

  var STORAGE_KEY = 'pw-bdl-v1';
  var EVENT = 'prowwl-bundle:change';

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Money: format cents from the store's own money format sample (1000.00) ---------- */
  var moneyFmt = null;
  function readMoney() {
    var sample = readJSON(document.querySelector('[data-pw-bdl-money]'));
    var fmt = { prefix: '$', suffix: '', thousands: ',', decimal: '.', decimals: 2 };
    if (typeof sample === 'string') {
      var text = sample.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
      var m = text.match(/1(\D?)000(?:(\D)(\d+))?/);
      if (m) {
        fmt.prefix = text.slice(0, m.index);
        fmt.suffix = text.slice(m.index + m[0].length);
        fmt.thousands = m[1] || '';
        fmt.decimal = m[2] || '';
        fmt.decimals = m[3] ? m[3].length : 0;
      }
    }
    moneyFmt = fmt;
  }
  function money(cents) {
    if (!moneyFmt) readMoney();
    var f = moneyFmt;
    var value = (Math.round(cents) / 100).toFixed(f.decimals);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.thousands);
    return f.prefix + whole + (f.decimals ? f.decimal + parts[1] : '') + f.suffix;
  }

  /* ---------- Config ---------- */
  var config = { threshold: 3, percent: 20, discountCode: '' };
  function readConfig() {
    var c = readJSON(document.querySelector('[data-pw-bdl-config]')) || {};
    config.threshold = Math.max(1, parseInt(c.threshold, 10) || 3);
    config.percent = Math.min(100, Math.max(0, parseFloat(c.percent) || 20));
    config.discountCode = (c.discountCode || '').trim();
  }

  /* ---------- Store ---------- */
  var catalog = {}; // variant id -> product info
  var items = []; // [{ id, qty }]

  function register(p) {
    if (!p || !p.id) return;
    p.id = String(p.id);
    catalog[p.id] = Object.assign({}, catalog[p.id] || {}, p);
  }

  function load() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && Array.isArray(saved.items)) {
        items = [];
        saved.items.forEach(function (it) {
          if (!it || !it.id || !(it.qty > 0)) return;
          if (it.p) register(it.p);
          items.push({ id: String(it.id), qty: Math.floor(it.qty) });
        });
      }
    } catch (e) { /* storage blocked: start empty */ }
  }

  function save() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        items: items.map(function (it) { return { id: it.id, qty: it.qty, p: catalog[it.id] || null }; })
      }));
    } catch (e) { /* storage blocked: keep in memory only */ }
  }

  function find(id) {
    id = String(id);
    for (var i = 0; i < items.length; i++) if (items[i].id === id) return items[i];
    return null;
  }

  function state() {
    var count = 0, subtotal = 0, lines = [];
    items.forEach(function (it) {
      var p = catalog[it.id];
      if (!p) return;
      count += it.qty;
      subtotal += p.price * it.qty;
      lines.push({ id: it.id, qty: it.qty, product: p, line: p.price * it.qty });
    });
    var unlocked = count >= config.threshold;
    /* Discount is rounded per line so the panel lines always add up to the total. */
    var discount = 0;
    lines.forEach(function (l) {
      l.off = unlocked ? Math.round(l.line * config.percent / 100) : 0;
      discount += l.off;
    });
    return {
      count: count,
      subtotal: subtotal,
      discount: discount,
      total: subtotal - discount,
      unlocked: unlocked,
      remaining: Math.max(0, config.threshold - count),
      threshold: config.threshold,
      percent: config.percent,
      progress: Math.min(1, count / config.threshold),
      lines: lines
    };
  }

  function emit(meta) {
    save();
    var detail = state();
    detail.meta = meta || {};
    document.dispatchEvent(new CustomEvent(EVENT, { detail: detail }));
  }

  function add(id, n, meta) {
    id = String(id);
    if (!catalog[id]) return;
    var it = find(id);
    if (it) it.qty += n || 1; else items.push({ id: id, qty: n || 1 });
    emit(meta || { type: 'add', ids: [id] });
  }
  function addMany(ids, meta) {
    ids.forEach(function (id) {
      id = String(id);
      if (!catalog[id]) return;
      var it = find(id);
      if (it) it.qty += 1; else items.push({ id: id, qty: 1 });
    });
    emit(meta || { type: 'add', ids: ids });
  }
  function setQty(id, qty) {
    id = String(id);
    var it = find(id);
    if (!it) { if (qty > 0) add(id, qty); return; }
    if (qty <= 0) items = items.filter(function (x) { return x.id !== id; });
    else it.qty = Math.floor(qty);
    emit({ type: 'qty', ids: [id] });
  }
  function remove(id) { setQty(id, 0); }
  function clear() { items = []; emit({ type: 'clear' }); }
  function qtyOf(id) { var it = find(id); return it ? it.qty : 0; }

  function fill(template, s, extra) {
    var map = {
      count: s.count, remaining: s.remaining, threshold: s.threshold, percent: s.percent,
      amount: extra && extra.amount != null ? extra.amount : money(s.discount),
      total: money(s.total), n: extra && extra.n != null ? extra.n : '', name: extra && extra.name != null ? extra.name : ''
    };
    return String(template || '').replace(/\[(count|remaining|threshold|percent|amount|total|n|name)\]/g, function (_, k) {
      return map[k];
    });
  }

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ---------- Hero tracker ---------- */
  function initTracker(root) {
    if (root.dataset.pwBdlBound) return;
    root.dataset.pwBdlBound = '1';
    var d = root.dataset;
    var msg = root.querySelector('[data-pw-bdl-msg]');
    var nowEl = root.querySelector('[data-pw-bdl-now]');
    var saveEl = root.querySelector('[data-pw-bdl-save]');
    var fillEl = root.querySelector('[data-pw-bdl-fill]');
    var nodesEl = root.querySelector('[data-pw-bdl-nodes]');
    var bar = root.querySelector('[role="progressbar"]');
    var builtFor = 0;

    function buildNodes(s) {
      if (!nodesEl || builtFor === s.threshold) return;
      builtFor = s.threshold;
      var html = '';
      for (var i = 1; i <= s.threshold; i++) {
        var last = i === s.threshold;
        var label = fill(i === 1 ? d.nodeOne : d.nodeMany, s, { n: i });
        html += '<li class="pw-bdl-step' + (last ? ' pw-bdl-step--last' : '') + '" style="left:' + (i / s.threshold * 100) + '%">' +
          (last && d.goal ? '<span class="pw-bdl-step__goal">' + escapeHtml(fill(d.goal, s)) + '</span>' : '') +
          '<span class="pw-bdl-step__dot">' + CHECK_SVG + '</span>' +
          '<span class="pw-bdl-step__label">' + escapeHtml(label) + '</span></li>';
      }
      nodesEl.innerHTML = html;
    }

    function render(s) {
      buildNodes(s);
      var t = s.unlocked ? d.msgUnlocked : (s.count === 0 ? d.msgStart : d.msgProgress);
      if (msg) msg.textContent = fill(t, s);
      if (nowEl) nowEl.textContent = money(s.total);
      if (saveEl) {
        saveEl.hidden = !s.unlocked || !s.discount;
        saveEl.textContent = fill(d.saveLabel, s);
      }
      if (fillEl) fillEl.style.width = (s.progress * 100) + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(Math.round(s.progress * 100)));
      if (nodesEl) {
        var nodes = nodesEl.children;
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].classList.toggle('is-hit', s.count >= i + 1);
          nodes[i].classList.toggle('is-next', s.count === i);
        }
      }
      root.classList.add('is-ready');
    }
    document.addEventListener(EVENT, function (e) { render(e.detail); });
    render(state());
  }

  /* ---------- Starter kits ---------- */
  function initKit(root) {
    if (root.dataset.pwBdlBound) return;
    root.dataset.pwBdlBound = '1';
    var products = readJSON(root.querySelector('[data-pw-bdl-kit-items]')) || [];
    products.forEach(register);
    var ids = products.filter(function (p) { return p.available; }).map(function (p) { return String(p.id); });
    var sum = products.reduce(function (a, p) { return a + p.price; }, 0);
    var wasEl = root.querySelector('[data-pw-bdl-kit-was]');
    var nowEl = root.querySelector('[data-pw-bdl-kit-now]');
    var saveEl = root.querySelector('[data-pw-bdl-kit-save]');
    var btn = root.querySelector('[data-pw-bdl-kit-add]');
    var timer = null;

    function renderPrice() {
      var s = state();
      var discounted = products.length >= config.threshold;
      var off = discounted ? products.reduce(function (a, p) { return a + Math.round(p.price * config.percent / 100); }, 0) : 0;
      if (nowEl) nowEl.textContent = money(sum - off);
      if (wasEl) { wasEl.hidden = !discounted; wasEl.innerHTML = '<s>' + escapeHtml(money(sum)) + '</s>'; }
      if (saveEl) { saveEl.hidden = !discounted; saveEl.textContent = fill(root.dataset.saveLabel, s, { amount: money(off) }); }
    }

    if (btn) {
      if (!ids.length) btn.disabled = true;
      btn.addEventListener('click', function () {
        if (!ids.length) return;
        addMany(ids, { type: 'kit', ids: ids, name: root.dataset.kitName || '' });
        btn.textContent = btn.dataset.doneLabel || btn.textContent;
        btn.classList.add('is-done');
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.textContent = btn.dataset.label;
          btn.classList.remove('is-done');
        }, 2200);
      });
    }
    renderPrice();
  }

  /* ---------- Builder: grid + panel ---------- */
  function iframeFetch() {
    try {
      var frame = document.getElementById('pw-bdl-fetch-frame');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = 'pw-bdl-fetch-frame';
        frame.src = 'about:blank';
        frame.setAttribute('aria-hidden', 'true');
        frame.tabIndex = -1;
        frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
        document.body.appendChild(frame);
      }
      var w = frame.contentWindow;
      if (w && typeof w.fetch === 'function') return w.fetch.bind(w);
    } catch (e) { /* fall through */ }
    return window.fetch.bind(window);
  }

  function initBuilder(root) {
    if (root.dataset.pwBdlBound) return;
    root.dataset.pwBdlBound = '1';
    var t = readJSON(root.querySelector('[data-pw-bdl-strings]')) || {};
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pw-bdl-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-pw-bdl-filter]'));
    var countEl = root.querySelector('[data-pw-bdl-visible-count]');
    var panel = root.querySelector('[data-pw-bdl-panel]');
    var scrim = root.querySelector('[data-pw-bdl-scrim]');
    var linesEl = root.querySelector('[data-pw-bdl-lines]');
    var emptyEl = root.querySelector('[data-pw-bdl-empty]');
    var totalsEl = root.querySelector('[data-pw-bdl-totals]');
    var live = root.querySelector('[data-pw-bdl-live]');
    var toggle = root.querySelector('[data-pw-bdl-toggle]');
    var checkoutBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pw-bdl-checkout]'));
    var errorEl = root.querySelector('[data-pw-bdl-error]');
    var busy = false;

    /* One card per flavor: the size toggle sets which variant Add and +/- act on. */
    function syncCard(card) {
      var q = qtyOf(card.dataset.variant);
      card.classList.toggle('is-in', q > 0);
      var v = card.querySelector('[data-pw-bdl-card-qty]');
      if (v) v.textContent = q;
    }
    function selectSize(card, btn) {
      if (!btn || btn.disabled) return;
      card.querySelectorAll('[data-pw-bdl-size]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      card.dataset.variant = btn.getAttribute('data-pw-bdl-size');
      var price = card.querySelector('[data-pw-bdl-price]');
      if (price) price.textContent = btn.getAttribute('data-price');
      var unit = card.querySelector('[data-pw-bdl-unit]');
      if (unit) unit.textContent = btn.getAttribute('data-unit') || '';
      var pill = card.querySelector('[data-pw-bdl-pill]');
      if (pill) pill.textContent = btn.textContent;
      var img = card.querySelector('.pw-bdl-card__media img');
      var src = btn.getAttribute('data-image');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      syncCard(card);
    }
    cards.forEach(function (card) {
      var ps = Array.prototype.slice.call(card.querySelectorAll('[data-pw-bdl-product]')).map(readJSON).filter(Boolean);
      if (!ps.length) return;
      ps.forEach(register);
      var pressed = card.querySelector('[data-pw-bdl-size][aria-pressed="true"]');
      card.dataset.variant = pressed ? pressed.getAttribute('data-pw-bdl-size') : String(ps[0].id);
      var addBtn = card.querySelector('[data-pw-bdl-add]');
      if (addBtn) addBtn.addEventListener('click', function () { var id = card.dataset.variant; add(id, 1, { type: 'add', ids: [id] }); });
      card.addEventListener('click', function (e) {
        var sz = e.target.closest('[data-pw-bdl-size]');
        if (sz) { selectSize(card, sz); return; }
        var b = e.target.closest('[data-pw-bdl-step]');
        if (!b) return;
        var id = card.dataset.variant;
        setQty(id, qtyOf(id) + (b.dataset.pwBdlStep === 'up' ? 1 : -1));
      });
    });

    /* Filters */
    function applyFilter(chip) {
      var sizes = (chip.dataset.sizes || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var shown = 0;
      cards.forEach(function (card) {
        var own = (card.dataset.size || '').toLowerCase().split(/\s+/).filter(Boolean);
        var match = own.filter(function (z) { return sizes.indexOf(z) !== -1; });
        var ok = !sizes.length || match.length > 0;
        card.hidden = !ok;
        if (ok) shown++;
        /* Filtering by size switches the card to that size. */
        if (sizes.length && match.length) {
          var btn = card.querySelector('[data-pw-bdl-size][data-size="' + match[0] + '"]');
          if (btn && btn.getAttribute('aria-pressed') !== 'true') selectSize(card, btn);
        }
      });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      if (countEl) countEl.textContent = fill(shown === 1 ? t.countOne : t.countMany, state(), { n: shown });
    }
    chips.forEach(function (chip) { chip.addEventListener('click', function () { applyFilter(chip); }); });
    if (chips.length) applyFilter(chips[0]);
    else if (countEl) countEl.textContent = fill(cards.length === 1 ? t.countOne : t.countMany, state(), { n: cards.length });

    /* Mobile panel open/close */
    function setOpen(open) {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (scrim) scrim.hidden = !open;
      document.documentElement.classList.toggle('pw-bdl-lock', open);
    }
    if (toggle) toggle.addEventListener('click', function () { setOpen(!panel.classList.contains('is-open')); });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) { setOpen(false); if (toggle) toggle.focus(); }
    });
    var mq = window.matchMedia('(min-width: 990px)');
    var onMq = function () { if (mq.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

    /* Panel lines */
    if (linesEl) {
      linesEl.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-act]');
        if (!b) return;
        var id = b.closest('[data-id]').dataset.id;
        if (b.dataset.act === 'up') setQty(id, qtyOf(id) + 1);
        else if (b.dataset.act === 'down') setQty(id, qtyOf(id) - 1);
        else if (b.dataset.act === 'remove') remove(id);
      });
    }

    function lineHtml(l, s) {
      var p = l.product;
      var img = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" width="52" height="52" loading="lazy">' : '';
      var off = l.off || 0;
      var price = s.unlocked
        ? '<s>' + escapeHtml(money(l.line)) + '</s>' + escapeHtml(money(l.line - off))
        : escapeHtml(money(l.line));
      var label = escapeHtml(p.name + (p.size ? ' ' + p.size : ''));
      return '<li class="pw-bdl-line" data-id="' + escapeHtml(l.id) + '">' +
        '<span class="pw-bdl-line__img">' + img + '</span>' +
        '<span class="pw-bdl-line__body"><span class="pw-bdl-line__name">' + escapeHtml(p.name) + '</span>' +
        '<span class="pw-bdl-line__meta">' + escapeHtml([p.size, money(p.price)].filter(Boolean).join(' · ')) + '</span></span>' +
        '<span class="pw-bdl-line__price">' + price + '</span>' +
        '<span class="pw-bdl-line__ctl">' +
          '<span class="pw-bdl-qty pw-bdl-qty--sm">' +
            '<button type="button" data-act="down" aria-label="' + escapeHtml(fill(t.decrease, s, { name: p.name + ' ' + (p.size || '') })) + '">&minus;</button>' +
            '<span class="pw-bdl-qty__val" aria-live="off">' + l.qty + '</span>' +
            '<button type="button" data-act="up" aria-label="' + escapeHtml(fill(t.increase, s, { name: p.name + ' ' + (p.size || '') })) + '">+</button>' +
          '</span>' +
          '<button type="button" class="pw-bdl-line__remove" data-act="remove" aria-label="' + escapeHtml(t.remove + ': ' + label) + '">' + escapeHtml(t.remove) + '</button>' +
        '</span></li>';
    }

    function render(s, meta) {
      /* Cards */
      cards.forEach(function (card) {
        var q = qtyOf(card.dataset.variant);
        card.classList.toggle('is-in', q > 0);
        var v = card.querySelector('[data-pw-bdl-card-qty]');
        if (v) v.textContent = q;
      });

      /* Panel heading counts */
      var countText = fill(s.count === 1 ? t.itemOne : t.itemMany, s);
      root.querySelectorAll('[data-pw-bdl-count]').forEach(function (el) { el.textContent = countText; });

      /* Lines */
      if (linesEl) linesEl.innerHTML = s.lines.map(function (l) { return lineHtml(l, s); }).join('');
      if (linesEl) linesEl.hidden = !s.lines.length;
      if (emptyEl) {
        emptyEl.hidden = !!s.lines.length;
        var emptyText = emptyEl.querySelector('p');
        if (emptyText) emptyText.textContent = fill(t.empty, s);
      }

      /* Meter + totals */
      var nudge = s.unlocked ? fill(t.unlocked, s) : fill(t.nudge, s);
      root.querySelectorAll('[data-pw-bdl-meter]').forEach(function (m) {
        m.hidden = !s.count;
        m.classList.toggle('is-unlocked', s.unlocked);
        var msgEl = m.querySelector('[data-pw-bdl-meter-msg]');
        if (msgEl) msgEl.textContent = nudge;
        var f = m.querySelector('[data-pw-bdl-meter-fill]');
        if (f) f.style.width = (s.progress * 100) + '%';
      });
      if (totalsEl) {
        totalsEl.hidden = !s.count;
        totalsEl.innerHTML =
          '<div><span>' + escapeHtml(t.subtotal) + '</span><span>' + escapeHtml(money(s.subtotal)) + '</span></div>' +
          (s.unlocked && s.discount ? '<div class="pw-bdl-totals__save"><span>' + escapeHtml(fill(t.savings, s)) + '</span><span>&minus;' + escapeHtml(money(s.discount)) + '</span></div>' : '') +
          '<div class="pw-bdl-totals__grand"><span>' + escapeHtml(t.total) + '</span><span>' + escapeHtml(money(s.total)) + '</span></div>';
      }

      /* Mobile bar */
      var l1 = root.querySelector('[data-pw-bdl-l1]');
      var l2 = root.querySelector('[data-pw-bdl-l2]');
      if (l1) l1.textContent = countText + ' · ' + money(s.total);
      if (l2) l2.textContent = s.count ? nudge : fill(t.barEmpty, s);

      checkoutBtns.forEach(function (b) { b.disabled = s.count < 1 || busy; });
      if (errorEl && meta && meta.type !== 'checkout') errorEl.hidden = true;

      /* Announce */
      if (live && meta && meta.ids && (meta.type === 'add' || meta.type === 'kit')) {
        if (meta.type === 'kit') live.textContent = fill(t.addedKit, s, { name: meta.name || '' });
        else {
          var p = catalog[meta.ids[0]];
          live.textContent = p ? fill(t.added, s, { name: p.name + (p.size ? ' ' + p.size : '') }) : '';
        }
      }
    }

    async function checkout() {
      var s = state();
      if (!s.count || busy) return;
      busy = true;
      checkoutBtns.forEach(function (b) {
        b.disabled = true; b.setAttribute('aria-busy', 'true');
        b.dataset.label = b.dataset.label || b.textContent; b.textContent = t.checkoutBusy || b.textContent;
      });
      if (errorEl) errorEl.hidden = true;
      try {
        var doFetch = iframeFetch();
        var res = await doFetch(window.location.origin + '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: s.lines.map(function (l) { return { id: Number(l.id), quantity: l.qty }; }) })
        });
        if (!res.ok) {
          var err = null;
          try { err = await res.json(); } catch (e) { /* ignore */ }
          throw new Error((err && (err.description || err.message)) || t.error);
        }
        items = [];
        save();
        var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var code = config.discountCode;
        window.location.href = code
          ? root_ + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout')
          : root_ + 'checkout'; /* 30% is an automatic discount, so go straight to checkout */
      } catch (e) {
        busy = false;
        checkoutBtns.forEach(function (b) {
          b.removeAttribute('aria-busy'); b.textContent = b.dataset.label;
        });
        if (errorEl) { errorEl.textContent = (e && e.message) || t.error; errorEl.hidden = false; }
        emit({ type: 'checkout' });
      }
    }
    checkoutBtns.forEach(function (b) { b.addEventListener('click', checkout); });

    document.addEventListener(EVENT, function (e) { render(e.detail, e.detail.meta); });
    render(state(), null);
  }

  /* ---------- Boot ---------- */
  function boot() {
    readConfig();
    readMoney();
    /* Saved selection first, so fresh product data rendered on the page overrides what was saved. */
    if (!PwBundle._loaded) { load(); PwBundle._loaded = true; }
    document.querySelectorAll('[data-pw-bdl-kit]').forEach(initKit);
    document.querySelectorAll('[data-pw-bdl-builder]').forEach(initBuilder);
    document.querySelectorAll('[data-pw-bdl-tracker]').forEach(initTracker);
    emit({ type: 'init' });
  }

  var PwBundle = window.PwBundle = {
    add: add, addMany: addMany, setQty: setQty, remove: remove, clear: clear,
    state: state, money: money, config: config, catalog: catalog, _loaded: false
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor: re-bind when a section is re-rendered. */
  document.addEventListener('shopify:section:load', boot);
})();
